import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid, Container, Typography, Card, CardContent, Box } from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import { useNavigate } from 'react-router-dom';
import { getUserGroups } from '../utils';

export default function EmployeeDashboardPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const userGroups = getUserGroups();
    if (userGroups === null || !userGroups.includes('associate')) {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>BillerBay Transmit | Employee Dashboard</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              Employee Dashboard
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Hi, {localStorage.getItem('username')}! Welcome to your dashboard.
            </Typography>
          </Grid>
          
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <WorkIcon sx={{ mr: 1 }} />
                  Your Workspace
                </Typography>
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <Typography variant="body1" color="text.secondary">
                    Your personalized dashboard is coming soon. 
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Use the navigation menu to access available features.
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
